import React, { Component } from 'react';
import ModalStore from "../stores/ModalStore";
import "./modal.css";

export default class Modal extends Component {
	constructor () {
		super();
		this.state = {
			openId: ModalStore.getOpenId()
		}
	}
	componentWillMount() {
	  	ModalStore.on("change",this.updateOpenId.bind(this))
	}
	componentWillUnmount() {
		ModalStore.removeListener("change",this.updateOpenId.bind(this))
	}
	updateOpenId () {
		this.setState({
			openId: ModalStore.getOpenId()
		})
	}

	render() {
		return this.props.id === this.state.openId ? (
				<div className="modal-bg columns">
					<div className=" row align-center align-middle" style={{height: "100%"}}>
						<div className="columns small-10">
							<div className="row modal-center">
								<div className="modal-close" onClick={ModalStore.closeModal.bind(ModalStore)}>X</div>
								{this.props.children}
							</div>
						</div>
					</div>
				</div>
			) : null;
	}
}


/** WEBPACK FOOTER **
 ** ./src/components/modal.js
 **/